import { LenderConcession } from '../../interfaces';

export const Chase: LenderConcession = {
  lenderNameRegEx: new RegExp('CHASE|JPMCB|JPMORGAN|JPMC|JPMGN'),
  standardMinimumPercent: 1.75,
  minimumDollarAmount: 15,
  apr: 7.5,
};
